import React from "react";

export class Keyword extends React.PureComponent {
    render() {
        const {keyword, count, bsStyle, style} = this.props;
        return (
            <React.Fragment>
                <span className={"label " + bsStyle + " keyword"}
                      style={style}
                      title={"[" + keyword.area + "] " + keyword.topic}>
                    {count !== undefined && count + 'x '}{keyword.code}
                </span>
                {' '}
            </React.Fragment>
        )
    }
}
